/* eslint-disable */
export const CARD_CHECKED = "card-checked";
export const CARD_MP_CHECKED = "card-mp-checked";
